import { TableCell } from "@mui/material";
import { useState } from "react";
import { Button, Modal } from "src/Components";
import { IFreezedCoveredCallTableReport } from "src/Interfaces/collateral";
import { getAdaptationReportTable } from "src/Requests/collateral";
import { CommonTableUI } from "src/Tables/TableTemplate/common";
import TableTemplate, {
  IAdditional,
  IAdditionalHeaderProps,
} from "src/Tables/TableTemplate/tableTemplate";

const AdaptationLogTableHeader = ({}: IAdditionalHeaderProps) => {
  return (
    <>
      <TableCell />
    </>
  );
};

const AdaptationLogTableCol: React.FC<{
  row: IFreezedCoveredCallTableReport;
  onAction: () => void;
}> = ({ row }) => {
  const [isLogModalOpen, setIsLogModalOpen] = useState(false);

  return (
    <>
      <TableCell>
        {isLogModalOpen ? (
          <Modal
            title="جزئیات"
            UI={
              <TableTemplate
                TableUI={({ reports }) => <CommonTableUI reports={reports} />}
                getDataTable={getAdaptationReportTable}
                searchParameters={
                  {
                    triggerId: row.id,
                  } as any
                }
              />
            }
            onClose={() => setIsLogModalOpen(false)}
          />
        ) : null}
        <Button
          onClick={() => setIsLogModalOpen(true)}
          text="جزئیات"
          variant="contained"
          className="table-btn"
        />
      </TableCell>
    </>
  );
};

export const AdaptationLogTable: IAdditional<IFreezedCoveredCallTableReport> = {
  getHeader: AdaptationLogTableHeader,
  getRow: AdaptationLogTableCol,
};
